<template>
  <div class="user-article-list">
    <div class="index-body center-block">
      <div class="list-block">
        <a-tabs v-model="queryForm.sort" @change="queryList(false)">
          <a-tab-pane :key="1" tab="最新"></a-tab-pane>
          <a-tab-pane :key="2" tab="最热"></a-tab-pane>
        </a-tabs>
        <article-list :list="list" :showLoadMore="!loadFinished"></article-list>
        <!-- 加载更多 -->
        <load-more-btn v-if="list.length && !loadFinished" v-model="loading" @loadMore="queryList(true)"></load-more-btn>
        <!-- 空状态 -->
        <a-empty v-if="firstLoad && list.length===0"/>
      </div>
      <aside class="aside-block">
        <user-profile :userName="userName" :headUrl="headUrl" :articleTotal="total"></user-profile>
        <hot-article></hot-article>
      </aside>
    </div>
  </div>
</template>
<script>
import ArticleList from './components/ArticleList.vue'
import LoadMoreBtn from '@/components/LoadMoreBtn.vue'
import HotArticle from '@/components/HotArticle.vue'
import UserProfile from '@/components/UserProfile.vue'
import { getList } from '@/utils/api'

export default {
  components: { ArticleList, LoadMoreBtn, HotArticle, UserProfile },
  data() {
    return {
      userName: '雅克', 
      headUrl: '',
      queryForm: {
        bugType: 'ALL',
        category: 'ALL',
        limit: 10,
        pageNo: 1,
        keyword: '',
        sort: 1, // 1: 最新 2:最热
        userId: '',
      },
      loadFinished: false, // 列表加载完成，已无更多
      loading: false,
      firstLoad: false,
      list: [],
      total: 0
    }
  },
  computed: {
    // 是否是当前登录用户
    isCurrentUser() {
      return this.$store.state.isGuest === 2 && this.$store.state.userInfo.uid === this.queryForm.userId
    }
  },
  watch: {
    $route: {
      handler: function (){
        this.init()
      },
      immediate: true
    },
    '$store.state.isGuest': {
      handler: function (){
        this.queryList()
      }
    }
  },
  methods: {
    init(){
      this.queryForm.userId = this.$route.params.uid
      this.userName = this.$route.query.userName || ''
      this.headUrl = this.$route.query.headUrl || ''
      if(this.$store.state.isGuest !== 0) {
        this.queryList()
      }
    },
    // 列表查询
    queryList(loadMore=false){
      if(loadMore) {
        this.queryForm.pageNo++
      } else {
        this.queryForm.pageNo = 1
      }
      this.loading = true
      this.queryForm.isCurrentUser = this.isCurrentUser
      getList(this.queryForm).then(res => {
        if(res.code !== 0) {
          this.$message.error(res.msg)
          return
        }
        if(loadMore) {
          this.list.push(...res.data.records)
        } else {
          this.list = res.data.records
        }
        this.total = res.data.total
        // 如果数据不足limit条，则表示已加载完
        this.loadFinished = res.data.records.length < this.queryForm.limit
      }).finally(()=> {
        this.loading = false
        this.firstLoad = true
      })
    },
    routeToUser(uid){
      this.$router.push(`/user-article-list/${uid}`)
    },
  }
}
</script>
<style lang="less" scoped>
.user-article-list {
  padding: 10px 0;
  height: 100%;
  .index-body {
    height: 100%;
    display: flex;
    flex-direction: row;
    overflow: hidden;
  }
  .aside-block {
    flex: 0 0 295px;
    font-size: 12px;
    line-height: 18px;
    font-weight: 400;
    overflow: hidden;
  }
  .list-block {
    flex: 1;
    height: 100%;
    overflow-y: auto;
    margin-right: 10px;
    background: #fff;
    border: 1px solid #e5e6e9;

  }
  .tag-info-block{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 150px;
    background: #fff;
    border: 1px solid #e5e6e9;
    margin-bottom: 10px;
    .tag-name {
      margin-bottom: 10px;
      font-size: 24px;
      color: rgba(4,12,44,0.85);
      line-height: 36px;
      font-weight: 600;
    }
    .text-color3 {
      font-size: 12px;
      line-height: 18px;
      font-weight: 400;
    }
    .text-color {
      font-weight: 600;
    }
  }
  .user-rank-block {
    width: 100%;
    padding: 0 20px 20px;
    background: #fff;
    border: 1px solid #e5e6e9;
    margin-bottom: 10px;
    .title-color {
      font-size: 16px;
      font-weight: 500;
      line-height: 48px;
    }
    .user-item {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      cursor: pointer;
      .icon-user {
        width: 48px;
        height: 48px;
        border: 1px solid #e5e6e9;
        border-radius: 50%;
        margin-right: 10px;
      }
      strong {
        font-size: 14px;
        color: #040C2C;
        line-height: 22px;
        font-weight: 500;
      }
      &:hover strong {
        color: #1740DC;
      }
    }
  }
}
</style>